import React from 'react'
import styles from '../../style/dah.module.css'
import Layout from '../../components/Layout/Layout'
import { StaticImage } from 'gatsby-plugin-image'
import { AnchorLink } from 'gatsby-plugin-anchor-links'

export default function dah() {
    return (
        <Layout>
            <div className={styles.container}>
                <div className={styles.layout}>
                    <div className={styles.wrapper}> 
                            <h1 className="title"><span className="underline">Дулаан алдагдлын хэмжилт</span></h1>
                            <StaticImage src="../../images/hemjilt-1.jpg" alt="hemjilt1"/>
                            <h1>
                            Дулаан алдагдлын хэмжилт гэж юу вэ?
                            </h1>
                            <p>
                            Барилга байгууламжийн хаших хийцийн дулаан алдагдал, цахилгаан байгууламжийн контактны халалт, дулааны хангамжийн шугам хоолой болон халаах хэрэгслийн халалт, дулааны алдагдлыг БНГУ-д үйлдвэрлэсэн TECTO testo 835 маркийн хэт улаан туяаны контактын термометр (дулааны камер)-аар хэмжилт хийж, хэмжилтийн үр дүнг бодит болон инфра зургаар харуулж мэргэжлийн өндөр түвшинд дүн шинжилгээ хийсэн тайланг  гаргаж танилцуулна. 
                            </p>
                            <h1>
                                Дулаан алдагдлын хэмжилт хийлгэх процесс
                            </h1>
                            <StaticImage src="../../images/hemjilt.jpg" alt="hemjilt"/>
                            <p>Танд барилга байгууламж, тоног төхөөрөмжийн дулаан алдагдлыг мэргэжлийн өндөр түвшинд гүйцэтгүүлэх шаардлагатай байгаа бол <AnchorLink to="/#contact" className={styles.link}>энд</AnchorLink> дарж дэлгэрэнгүй мэдээлэл авна уу. </p>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
